import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { MoveList } from 'chessboard/model/move-list/types';
import { deleteMove } from 'src/shared/delete-move';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';

/**
 * Create Delete Move action
 */
export function createDeleteMove(_store: Store, _storeActions: StoreActions): ContextMenu.Action {
  return {
    getDisplayName: () => MoveList.Translation.Actions.DeleteMove,
    action: CONTEXT_MENU_ACTION_NAMES.DeleteMove,
    isVisible,
    handler,
  };

  /**
   * Visible on all nodes
   */
  function isVisible() {
    return true;
  }

  /**
   * handler to delete move
   */
  function handler({ node, game }: ContextMenu.ActionHandlerContext): void {
    deleteMove({ node, api: game });
  }
}
